<div class="filters">
  <div class="filter">
    <label for="idrId">IDR-ID</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterAggregates()"
        [(ngModel)]="filter.idrId"
        id="idrId"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>

  <div class="filter">
    <label for="name">Anlagenname</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterAggregates()"
        [(ngModel)]="filter.name"
        id="name"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>

  <div class="filter">
    <label for="type">Type</label>
    <p-multiSelect
      (keydown.enter)="filterAggregates()"
      [(ngModel)]="filter.type"
      [options]="types"
      display="chip"
      inputId="type"
      placeholder="Alle"
      scrollHeight="250px"
    />
  </div>

  <div class="filter">
    <label for="location">Aufstellungsort</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterAggregates()"
        [(ngModel)]="filter.location"
        id="location"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>

  <div class="filter">
    <label for="customerId">Kunden-ID</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        (keydown.enter)="filterAggregates()"
        [(ngModel)]="filter.customerId"
        id="customerId"
        pInputText
        placeholder="Suchen"
        type="text"
      />
    </p-iconField>
  </div>

  <div class="filter">
    <label for="status">Insp.-Status</label>
    <p-multiSelect
      (keydown.enter)="filterAggregates()"
      [(ngModel)]="filter.status"
      [options]="statuses"
      display="chip"
      inputId="status"
      placeholder="Alle"
      scrollHeight="250px"
    />
  </div>

  <div class="filter date-filter">
    <label for="inspectionDate">Insp.-Datum</label>
    <div class="input-wrapper">
      <p-calendar
        [(ngModel)]="filter.inspectionDateRange"
        [iconDisplay]="'input'"
        [ngClass]="{'invalid-input': !isInspectionRangeValid()}"
        [showButtonBar]="true"
        [showIcon]="true"
        dateFormat="dd.mm.yy"
        inputId="inspectionDate"
        placeholder="Datum"
        selectionMode="range"
      />
      <div *ngIf="!isInspectionRangeValid()" class="error">Bitte wählen Sie Start- und Enddatum aus.</div>
    </div>
  </div>

  <app-button (click)="filterAggregates()" label="Filtern" type="primary-button" />
  <app-button (click)="clearFilter()" label="Filter zurücksetzen" type="secondary-button" />
</div>
